import React from 'react';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

const VerificationPending = () => {
  const navigate = useNavigate();
  const [resendStatus, setResendStatus] = React.useState('');
  const email = localStorage.getItem('pendingVerificationEmail');

  const handleResendEmail = async () => {
    try {
      const response = await api.resendVerificationEmail();
      setResendStatus('success');
    } catch (error) {
      console.error('Error al reenviar el correo:', error);
      setResendStatus('error');
    }
  };

  return (
    <Container component="main" maxWidth="sm" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5" gutterBottom>
          Verifica tu correo electrónico
        </Typography>
        
        <Typography variant="body1" align="center" sx={{ mt: 2 }}>
          Hemos enviado un correo de verificación a:
          <Box component="span" sx={{ fontWeight: 'bold', display: 'block' }}>
            {email}
          </Box>
        </Typography>

        <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
          Por favor, revisa tu bandeja de entrada y sigue las instrucciones para verificar tu cuenta.
        </Typography>

        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}>
          <Button
            variant="outlined"
            onClick={handleResendEmail}
            disabled={resendStatus === 'success'}
          >
            Reenviar correo de verificación
          </Button>

          <Button
            variant="text"
            onClick={() => navigate('/login')}
          >
            Volver al inicio de sesión
          </Button>
        </Box>

        {resendStatus === 'success' && (
          <Typography color="success.main" sx={{ mt: 2 }}>
            Correo de verificación reenviado exitosamente
          </Typography>
        )}

        {resendStatus === 'error' && (
          <Typography color="error" sx={{ mt: 2 }}>
            Error al reenviar el correo. Por favor, intenta nuevamente.
          </Typography>
        )}
      </Paper>
    </Container>
  );
};

export default VerificationPending; 